import React, { useContext, useEffect, useState } from "react";
//
import NotifyBasic from "../../common/components/notify/NotifyBasic";
//
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
//

const DURATION = 8000;

const CommonNotify = () => {
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { common } = state;
  const { message } = common;
  // local state
  const [open, setOpen] = useState(false);

  //
  useEffect(() => {
    if (message.open) {
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
        dispatch({
          type: Act.COMMON_CLEAR_MESSAGE,
        });
      }, message.duration || DURATION);
    }
  }, [message]);

  return (
    <NotifyBasic
      open={open}
      message={message.content}
      type={message.type}
      duration={DURATION}
    />
  );
};

export default CommonNotify;
